import { render, staticRenderFns } from "./CartContent.vue?vue&type=template&id=520bb9c2&scoped=true"
import script from "./CartContent.vue?vue&type=script&lang=js"
export * from "./CartContent.vue?vue&type=script&lang=js"
import style0 from "./CartContent.vue?vue&type=style&index=0&id=520bb9c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520bb9c2",
  null
  
)

export default component.exports